module.exports = __webpack_public_path__ + "img/pwa-install.b3bfb124.png";